import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
import { OrdersService } from '@app/services/order/orders.service';
import { ToastrService } from 'ngx-toastr';
// import { OrderTypeComponent } from '@app/modules/modals/order-type/order-type.component';
@Component({
    selector: 'summary',
    templateUrl: 'summary.component.html',
    styleUrls: ['summary.component.scss']
})

export class SummaryComponent {
    order: any = {};
    elementsNbr: number;
    orderTypes: any[] = [];
    chosenOrderType: number;
    orderType: number;
    orderTypLabel: string;
    @Output()
    onNext: EventEmitter<boolean> = new EventEmitter<boolean>();
    bsModalRef: BsModalRef;
    subscriptions: Subscription[] = [];
    subscriptions2: Subscription[] = [];
    modalRef: BsModalRef;
    @ViewChild("template") template;
    amountMiniDelivery: number;
    amountMiniMandatory: number;
    @ViewChild("template2") template2;
    constructor(
        private orderService: OrdersService,
        private pdvService: PdvService,
        private route: Router,
        private modalService: BsModalService,
        private toastr: ToastrService
    ) {
        let sub1 = this.orderService.order.subscribe(
            (order) => {
                this.order = order;
                this.elementsNbr = order.elementsNbr;
                if (order.elementsNbr == 0) {
                    this.route.navigate(['/carte'])
                }
            }
        )
        let sub3 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
            if (this.orderTypes.length > 1 && this.chosenOrderType > 0) {
                this.orderTypLabel = this.orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
            }
        });
        let sub4 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.orderTypes.length > 1 && this.chosenOrderType > 0) {
                this.orderTypLabel = this.orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
            }
        });
        const subs5 = this.pdvService.pdv.subscribe(
            (data: any) => {
                this.amountMiniMandatory = data.amountMiniMandatory;
            }
        )
        const subs7 = this.orderService.amountMiniDelivery.subscribe(amountMiniDelivery => {
            this.amountMiniDelivery = amountMiniDelivery;
        });
        this.subscriptions2.push(sub1, sub3, sub4, subs5)
    }

    incrQty(i, j) {
        this.orderService.incrQty(i, j);
    }

    decrQty(i, j) {
        this.orderService.decrQty(i, j);
    }

    removeElement(i, j) {
        this.orderService.removeElement(i, j);
    }

    validate() {
        if (this.chosenOrderType == 1) {
            if (Number(this.order.amount) >= Number(this.amountMiniDelivery)) {
                this.goToConfirmation();
            } else {
                if (this.amountMiniMandatory == 1) {
                    this.toastr.error('', 'Minimum de livraison: ' + this.amountMiniDelivery + ' €');
                } else {
                    this.goToConfirmation();
                }
            }
        } else {
            this.goToConfirmation();
        }
    }

    goToConfirmation() {
        this.orderService.order.next(this.order);
        this.onNext.emit(true);
    }

    // setOrderTypeEvent() {
    //     this.bsModalRef = this.modalService.show(OrderTypeComponent, {
    //         class: "modal-content2"
    //     });
    //     const _combine = combineLatest(
    //         this.modalService.onHidden
    //     ).subscribe(() => this.changeDetection.markForCheck());
    //     this.subscriptions.push(
    //         this.modalService.onHidden.subscribe((data: any) => {
    //             if (data) {
    //                 if (this.chosenOrderType !== data.orderType) {
    //                     this.orderService.chosenOrderType.next(data.orderType);
    //                     // this.orderService.orderType.next(data.orderType);
    //                     this.orderType = data.orderType;
    //                 }
    //             }
    //             this.unsubscribe();
    //         })
    //     );
    //     this.subscriptions.push(_combine);
    // }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    changeMode() {
        if (this.elementsNbr > 0) {
            this.modalRef = this.modalService.show(this.template, {
                class: "modal-sm"
            });
        } else {
            // this.setOrderTypeEvent();
        }
    }
    confirm() {
        this.modalRef.hide();
        this.orderService.clearOrder();
        setTimeout(() => {
            // this.setOrderTypeEvent();
            this.route.navigate(['/modes']);
        }, 1000)
    }

    decline() {
        this.modalRef.hide();
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
}
